<div class="summary-questionnaire-container">
  <div class="questionnaire-content-header">
    <div class="questionnaire-title">
      {{ questionnaireContent.summaryTitle }}
    </div>
    <div class="questionnaire-sub-title" [innerHTML]="questionnaireContent.summarySubTitle"></div>
  </div>
  <div class="questionnaire-file">
    <div class="questionnaire-details-file">
      <u-icon [model]="{ type: 'font', value: 'icon-answer' }" [styles]="{ color: 'var(--color-primary)', fontSize: '16px' }"></u-icon>
      <span class="questionnaire-file-name">
        {{ questionnaireContent.requestForProposal }} <span class="name">{{ data.fileName }} </span>.{{ data.extension }}
      </span>
    </div>

    <u-button
      class="questionnaire-action"
      type="primary"
      (onClick)="downloadFile()"
      [label]="'Download File'"
      [styles]="{ width: '171px' }"
    ></u-button>
  </div>
  <ng-scrollbar class="summary-questionnaire-content" visibility="hover">
    <div class="summary-total">
      <div class="flex">
        <div class="summary-total-title">{{ questionnaireContent.summaryTotal }}</div>
        <div class="summary-total-completed">
          <span class="text-bolder"> {{ questionsTotal }}/</span>
          <span class="text-regular">{{ questionsTotal }} </span>
          <span class="text-bold">Completed</span>
        </div>
      </div>
      <div class="flex">
        <div class="summary-total-answered text-bold">{{ answeredTotal }} Answered</div>
        <div class="summary-total-details">
          <span class="summary-total-no-answered">{{ noAnsweredTotal }} Not answered </span>
          <span class="summary-total-failed">{{ failedTotal }} Failed</span>
        </div>
      </div>
    </div>
    <div class="summary-worksheets" *ngFor="let ws of summaryWorksheets">
      <div class="flex">
        <div class="worksheet-name text-bold">{{ ws.name }}</div>
        <div class="worksheet-completed">
          <span class="text-bolder"> {{ ws.answered }}</span>
          <span class="text-regular">/{{ ws.total }} </span>
        </div>
      </div>
      <div class="flex">
        <div class="worksheets-answered text-bold">{{ ws.answered }} Answered</div>
        <div class="worksheets-no-answered">
          <span>{{ ws.notAnswered }} Not answered</span>
          <span>{{ ws.failed }} Failed</span>
        </div>
      </div>
    </div>
  </ng-scrollbar>
</div>
